const LOCALHOST_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1', '[::1]']);

export const parseSampleRate = (
  rawValue: string | undefined,
  fallback: number,
): number => {
  if (rawValue === undefined || rawValue.trim() === '') return fallback;

  const parsed = Number(rawValue);
  if (!Number.isFinite(parsed)) return fallback;
  return Math.min(100, Math.max(0, parsed));
};

export const isLocalhostHostname = (hostname: string): boolean =>
  LOCALHOST_HOSTNAMES.has(hostname);
